import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
export function ProtectedRoute({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    user,
    isLoading
  } = useAuth();
  const location = useLocation();

  // ⏳ Loading (nunggu Supabase cek session)
  if (isLoading) {
    return <div className="min-h-screen flex items-center justify-center bg-white" data-id="element-135">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-dark" data-id="element-136"></div>
      </div>;
  }

  // 🔒 Kalau belum login → redirect ke login
  if (!user) {
    return <Navigate to="/login" state={{
      from: location
    }} replace data-id="element-137" />;
  }

  // ✅ Kalau sudah login → tampilkan halaman
  return <>{children}</>;
}